import * as api from '../../services/ios'

export const FETCH_IOSS= 'FETCH_IOSS';
export const FETCH_IOS = 'FETCH_IOS';


export const fetchIos = (id) => ({
    type: FETCH_IOS,
    payload: {
        promise: api.findIos({id: id})
    }
});


export const fetchIoss = (params, pagination, sort, extra) => {

    return {
        type: FETCH_IOSS,
        payload: {
            promise: api.findIoss(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/ios.js